import script from "./ConsentBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConsentBanner.vue?vue&type=script&setup=true&lang=ts"

import "./ConsentBanner.vue?vue&type=style&index=0&id=785c7949&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-785c7949"]])

export default __exports__